/* Black Hound theme scripts */
(function () {
  'use strict';

  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));


  /* Shopify CDN sizing. The legacy filename suffix (_160x200_crop_center) is
     no longer served, and the previous regex contained doubled backslashes so
     it never matched. Modern URLs take width/height as query parameters. */
  /* Width only. It used to ask the CDN for a fixed height with
     crop=center, so a wide product shot (a cap) arrived with its sides
     already cut off, before any CSS could show the whole thing. The box
     the image sits in sets the shape; the file stays whole. */
  function sized(url, w) {
    if (!url) return '';
    const base = url.split('?')[0];
    let q = url.indexOf('?') > -1 ? url.split('?')[1] : '';
    q = q.replace(/(^|&)(width|height|crop)=[^&]*/g, '').replace(/^&/, '');
    const parts = q ? [q] : [];
    parts.push('width=' + w);
    return base + '?' + parts.join('&');
  }

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = window.BH && BH.moneyFormat ? BH.moneyFormat : '£{{amount}}';
    const amt = (cents / 100).toFixed(2);
    const withCommas = amt.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (/\{\{\s*amount_no_decimals\s*\}\}/.test(fmt)) {
      return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString());
    }
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('#BHToast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 2600);
  }
  window.bhToast = toast;

  /* ---------- drawers ---------- */
  const scrim = $('#BHScrim');
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    // A drawer rendered inside the sticky header section is trapped in its
    // stacking context (z-index 60) and ends up under the scrim (z-index 90),
    // so lift it to <body>. Drop any stale copy left by a theme-editor re-render.
    if (d.parentElement !== document.body) {
      $$('body > [id="' + id + '"]').forEach((o) => o.remove());
      document.body.appendChild(d);
    }
    closeDrawers(true);
    d.classList.add('is-open');
    d.removeAttribute('hidden');
    if (scrim) { scrim.hidden = false; scrim.classList.add('is-open'); }
    document.body.style.overflow = 'hidden';
    const focusable = d.querySelector('button, a, input');
    if (focusable) setTimeout(() => focusable.focus(), 120);
  }
  function closeDrawers(keepScroll) {
    $$('.drawer').forEach((d) => d.classList.remove('is-open'));
    $$('.mpanel').forEach((p) => p.classList.remove('is-open'));
    if (scrim) { scrim.classList.remove('is-open'); setTimeout(() => { if (!$('.drawer.is-open')) scrim.hidden = true; }, 260); }
    if (!keepScroll) document.body.style.overflow = '';
  }
  window.bhOpenDrawer = openDrawer;
  window.bhCloseDrawers = closeDrawers;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-close-all]')) { closeDrawers(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- announcement rotation ---------- */
  const slides = $$('.announce__slide');
  if (slides.length > 1) {
    let i = 0;
    setInterval(() => {
      if (document.body.classList.contains('announce-paused')) return;
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, 4500);
  }

  /* ---------- accordions ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.acc__btn');
    if (!btn) return;
    const item = btn.closest('.acc__item');
    const open = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    const ico = btn.querySelector('.acc__ico');
    if (ico) ico.textContent = open ? '\u2212' : '+';
  });

  /* ---------- card colour swatches: swap image ---------- */



  /* ---------- wishlist (local) ---------- */
  const WKEY = 'bh_wishlist';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wishSet(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} }
  function paintWish() {
    const list = wishGet();
    $$('.pcard__wish[data-handle]').forEach((b) => {
      b.classList.toggle('is-on', list.indexOf(b.dataset.handle) > -1);
    });
    const c = $('#WishCount');
    if (c) { c.textContent = list.length; c.style.display = list.length ? 'grid' : 'none'; }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.pcard__wish[data-handle]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    const list = wishGet();
    const idx = list.indexOf(b.dataset.handle);
    if (idx > -1) { list.splice(idx, 1); toast('Removed from wishlist'); }
    else { list.push(b.dataset.handle); toast('Saved to wishlist'); }
    wishSet(list);
    paintWish();
  });
  paintWish();

  /* ---------- cart ---------- */
  const cartUrls = {
    add: (window.BH && BH.addUrl) || '/cart/add',
    cart: (window.BH && BH.cartUrl) || '/cart',
    change: (window.BH && BH.changeUrl) || '/cart/change'
  };

  function getCart() {
    return fetch(cartUrls.cart + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  }


  /* P0-QIKIFY-001 / P0-ROUTES-001
     Posts the real form. multipart/form-data is required for file uploads,
     so no Content-Type header is set: the browser sets the boundary. */
  function addFormToCart(form) {
    const fd = new FormData(form);
    return fetch(cartUrls.add + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd
    }).then((r) => r.json().then((d) => ({ ok: r.ok, data: d })));
  }

  /* minimal locale lookup; strings are injected from Liquid (I18N groundwork) */
  function t(key, fallback) {
    const dict = (window.BH && BH.strings) || {};
    return dict[key] || fallback;
  }

  function addToCart(id, qty) {
    return fetch(cartUrls.add + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then((r) => r.json().then((d) => ({ ok: r.ok, data: d })));
  }

  function changeLine(key, qty) {
    return fetch(cartUrls.change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then((r) => r.json());
  }


  /* P0-QIKIFY-001: render line-item properties (Qikify/Tepo customisations).
     Shopify hides properties whose key starts with "_". File uploads arrive
     as URLs and are linked so the customer can verify what they submitted. */
  function propertiesHtml(item) {
    const props = item.properties;
    if (!props) return '';
    const rows = [];
    Object.keys(props).forEach((k) => {
      if (k.indexOf('_') === 0) return;
      const v = props[k];
      if (v === null || v === undefined || v === '') return;
      const isUrl = typeof v === 'string' && /^https?:\/\//.test(v);
      const val = isUrl
        ? '<a href="' + v + '" target="_blank" rel="noopener">' + t('cart.general.view_file', 'View file') + '</a>'
        : String(v).replace(/[<>&]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]));
      rows.push('<li><span class="citem__propk">' + k + ':</span> ' + val + '</li>');
    });
    return rows.length ? '<ul class="citem__props">' + rows.join('') + '</ul>' : '';
  }

  /* for text going into a quoted HTML attribute - a product called 6" Sock
     or Kit & Caps would otherwise cut the attribute short */
  function attr(s) {
    return String(s == null ? '' : s).replace(/[&"<>]/g, (c) =>
      ({ '&': '&amp;', '"': '&quot;', '<': '&lt;', '>': '&gt;' }[c]));
  }

  function renderCart(cart) {
    const badge = $('#CartCount');
    if (badge) {
      const prev = parseInt(badge.textContent || '0', 10);
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count ? 'grid' : 'none';
      if (cart.item_count > prev) {
        badge.classList.remove('is-bump');
        void badge.offsetWidth;
        badge.classList.add('is-bump');
      }
    }

    const body = $('#CartItems');
    const foot = $('#CartFoot');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><p>Your bag is empty.</p><a class="btn btn--ink" href="/collections/all">Start shopping</a></div>';
      if (foot) foot.style.display = 'none';
      document.dispatchEvent(new CustomEvent('bh:cart-updated', { detail: cart }));
      return;
    }
    if (foot) foot.style.display = '';

    let html = '';
    const threshold = (window.BH && BH.freeShipThreshold) || 0;
    if (threshold > 0) {
      const remain = threshold - cart.total_price;
      const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      html += '<div class="ship ' + (remain <= 0 ? 'ship--done' : '') + '">' +
        '<div class="ship__msg">' +
        (remain > 0
          ? "You're <b>" + money(remain) + '</b> away from <b>free UK delivery</b>'
          : "\u2713 You've unlocked <b>free UK delivery</b>") +
        '</div><div class="ship__track"><div class="ship__fill" style="width:' + pct + '%"></div></div></div>';
    }

    html += '<div class="cartd__notice">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 8v5"/><path d="M12 16h.01"/></svg>' +
      '<span><b>Your items are not reserved.</b> Check out soon to make sure you do not miss out.</span></div>';

    cart.items.forEach((it) => {
      const img = it.image ? sized(it.image, 200) : '';
      const opts = it.options_with_values
        ? it.options_with_values.map((o) => o.value).join(' \u00b7 ')
        : (it.variant_title || '');
      const unit = it.quantity > 1 ? '<span class="citem__unit">' + money(it.final_price) + ' each</span>' : '';
      html += '<div class="citem" data-key="' + it.key + '">' +
        /* eager, sized and named, to match what Liquid renders server-side:
           the drawer is open the instant this runs, so there is nothing to
           defer, and the wrapping link has no text of its own to name it */
        (img ? '<a href="' + it.url + '"><img class="citem__img" src="' + img + '" alt="' + attr(it.product_title) + '" width="80" height="100" loading="eager" decoding="async"></a>' : '<div class="citem__img"></div>') +
        '<div style="flex:1;min-width:0">' +
          '<a href="' + it.url + '"><div class="citem__title">' + it.product_title + '</div></a>' +
          (opts ? '<div class="citem__meta">' + opts + '</div>' : '') +
          propertiesHtml(it) +
          '<div class="citem__price">' + money(it.final_line_price) + unit + '</div>' +
          '<div class="citem__bottom">' +
            '<div class="qty">' +
              '<button data-qty="down" aria-label="Decrease">\u2212</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button data-qty="up" aria-label="Increase">+</button>' +
            '</div>' +
            '<div class="citem__acts">' +
              '<button class="citem__move" data-move-wish="' + it.handle + '">Save</button>' +
              '<a href="#" class="citem__remove" data-remove>Remove</a>' +
            '</div>' +
          '</div>' +
        '</div></div>';
    });

    body.innerHTML = html;
    const sub = $('#CartSubtotal');
    if (sub) sub.textContent = money(cart.total_price);
    const tot = $('#CartTotal');
    if (tot) tot.textContent = money(cart.total_price);
    const tabn = $('#CartTabCount');
    if (tabn) { tabn.textContent = cart.item_count; tabn.style.display = cart.item_count ? '' : 'none'; }
    document.dispatchEvent(new CustomEvent('bh:cart-updated', { detail: cart }));
  }

  function refreshCart(open) {
    return getCart().then((c) => {
      renderCart(c);
      if (open) {
        const mode = (window.BH && BH.afterAdd) || 'drawer';
        if (mode === 'checkout') { window.location.href = '/checkout'; return c; }
        if (mode === 'cart') { window.location.href = cartUrls.cart; return c; }
        openDrawer('CartDrawer');
        loadUpsell(c);
      }
      return c;
    });
  }
  window.bhRefreshCart = refreshCart;

  /* quantity + remove inside drawer */
  document.addEventListener('click', (e) => {
    const row = e.target.closest('.citem[data-key]');
    if (!row) return;
    const key = row.dataset.key;
    const qtyBtn = e.target.closest('[data-qty]');
    const rm = e.target.closest('[data-remove]');
    if (!qtyBtn && !rm) return;
    e.preventDefault();
    const current = parseInt(row.querySelector('.qty span').textContent, 10) || 1;
    let next = current;
    if (rm) next = 0;
    else next = qtyBtn.dataset.qty === 'up' ? current + 1 : current - 1;
    changeLine(key, next).then(renderCart);
  });

  /* quick add from cards */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.getAttribute('data-variant-id');
    if (!id) { window.location.href = btn.getAttribute('data-url') || '#'; return; }
    btn.classList.add('is-disabled');
    addToCart(id, 1).then((res) => {
      btn.classList.remove('is-disabled');
      if (!res.ok) { toast(res.data.description || 'Could not add to bag'); return; }
      toast('Added to bag');
      refreshCart(true);
    }).catch(() => { btn.classList.remove('is-disabled'); toast('Could not add to bag'); });
  });

  /* ---------- product page ---------- */
  function initProduct() {
    /* Liquid's {% form 'product' %} tag names the element product-form-<section
       id>; nothing has ever rendered #ProductForm. Looking for that id meant
       this function returned on its own first line, so none of the product
       page was wired up: option pills, per-variant price and availability,
       the variant in the URL, and the ajax add were all dead. Match the class
       the section sets, then fall back to any add-to-cart form. */
    const form = $('#ProductForm')
              || $('[data-product] form.pdp__form')
              || $('form.pdp__form')
              || $('form[action*="/cart/add"]');
    if (!form) return;
    /* a missing wrapper must not throw; the whole document is a fine scope */
    const root = form.closest('[data-product]') || document;
    const varsEl = $('#ProductVariants');
    if (!varsEl) return;
    let variants = [];
    try { variants = JSON.parse(varsEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    const selected = {};
    $$('[data-opt-group]', root).forEach((g) => {
      const active = g.querySelector('[data-opt-value].is-active');
      selected[g.dataset.optGroup] = active ? active.dataset.optValue : null;
    });

    function findVariant() {
      return variants.find((v) =>
        Object.keys(selected).every((pos) => !selected[pos] || v['option' + pos] === selected[pos])
      );
    }

    function updateUI() {
      const v = findVariant();
      const idInput = $('#VariantId');
      const btn = $('#AddToCart');
      const priceEl = $('#PdpPrice');
      const stickyBtn = $('#StickyAdd');

      /* guarded throughout: a template that omits one of these must not take
         the rest of the selector down with it */
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          let ph = '<span>' + money(v.price) + '</span>';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            ph = '<span class="price--now">' + money(v.price) + '</span><span class="price--was">' + money(v.compare_at_price) + '</span>';
          }
          priceEl.innerHTML = ph;
        }
        const label = v.available ? 'Add to bag' : 'Sold out';
        if (btn) {
          btn.textContent = label;
          btn.disabled = !v.available;
          btn.classList.toggle('is-disabled', !v.available);
        }
        if (stickyBtn) { stickyBtn.textContent = label; stickyBtn.disabled = !v.available; }
        /* the product view follows the chosen colour */
        root.dispatchEvent(new CustomEvent('bh:variant', { detail: v, bubbles: true }));
        if (v.featured_image && v.featured_image.position) {
          const track = $('#GalTrack');
          if (track) {
            const idx = v.featured_image.position - 1;
            if (idx >= 0) track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
          }
        }
        const nb = $('#NotifyBox');
        if (nb) { if (v.available) nb.setAttribute('hidden',''); else nb.removeAttribute('hidden'); }
        const url = new URL(window.location);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      } else if (btn) {
        btn.textContent = 'Unavailable';
        btn.disabled = true;
      }

      /* grey out sizes unavailable in the chosen colour */
      $$('[data-opt-group]', root).forEach((g) => {
        const pos = g.dataset.optGroup;
        $$('[data-opt-value]', g).forEach((el) => {
          const probe = Object.assign({}, selected);
          probe[pos] = el.dataset.optValue;
          const match = variants.find((v) =>
            Object.keys(probe).every((p) => !probe[p] || v['option' + p] === probe[p])
          );
          el.classList.toggle('is-out', !match || !match.available);
        });
      });
    }

    root.addEventListener('click', (e) => {
      const el = e.target.closest('[data-opt-value]');
      if (!el) return;
      e.preventDefault();
      const group = el.closest('[data-opt-group]');
      $$('[data-opt-value]', group).forEach((x) => x.classList.remove('is-active'));
      el.classList.add('is-active');
      selected[group.dataset.optGroup] = el.dataset.optValue;
      const disp = group.querySelector('[data-opt-display]');
      if (disp) disp.textContent = el.dataset.optValue;
      updateUI();
    });

    updateUI();

    /* ajax add */
    /* P0-QIKIFY-001: submit the complete FormData so app-generated option
       fields, line-item properties and uploaded files survive. Never
       reconstruct the payload as { id, quantity }. */
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (form.dataset.busy === '1') return;

      /* let the browser and any app validation run first */
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

      const btn = $('#AddToCart');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = t('products.product.adding', 'Adding...'); btn.disabled = true; }
      form.dataset.busy = '1';

      addFormToCart(form).then((res) => {
        form.dataset.busy = '';
        if (btn) { btn.textContent = original; btn.disabled = false; }
        if (!res.ok) { toast((res.data && res.data.description) || t('cart.general.add_error', 'Could not add to bag')); return; }
        toast(t('cart.general.added', 'Added to bag'));
        refreshCart(true);
      }).catch(() => {
        form.dataset.busy = '';
        if (btn) { btn.textContent = original; btn.disabled = false; }
        toast(t('cart.general.add_error', 'Could not add to bag'));
      });
    });

    /* P0-QIKIFY-001: sticky ATC drives the real form. It must never be a
       second purchase engine. */
    const stickyAdd = $('#StickyAdd');
    if (stickyAdd && !stickyAdd.dataset.bound) {
      stickyAdd.dataset.bound = '1';
      stickyAdd.addEventListener('click', () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    /* sticky bar on mobile after ATC scrolls away */
    const bar = $('#PdpSticky');
    const atc = $('#AddToCart');
    if (bar && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -80px 0px' }).observe(atc);
    }
  }

  /* ---------- loyalty progress paint ---------- */
  function initTier() {
    $$('.chukka').forEach((c) => {
      const pct = parseFloat(c.dataset.progress || '0');
      const segs = $$('.chukka__seg i', c);
      const per = 100 / segs.length;
      segs.forEach((s, idx) => {
        const fill = Math.max(0, Math.min(100, (pct - idx * per) / per * 100));
        setTimeout(() => { s.style.width = fill + '%'; }, 80 + idx * 90);
      });
    });
  }


  /* ---------- mobile nav accordions ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-mnav-toggle]');
    if (!t) return;
    const panel = t.nextElementSibling;
    if (!panel || !panel.classList.contains('mnav__sub')) return;
    const open = panel.hasAttribute('hidden');
    if (open) panel.removeAttribute('hidden'); else panel.setAttribute('hidden', '');
    const sign = t.querySelector('span');
    if (sign) sign.textContent = open ? '\u2212' : '+';
  });

  /* ---------- rail carousel arrows ---------- */
  function initRails() {
    $$('[data-rail-nav]').forEach((nav) => {
      /* already wired: just re-check the arrows, the rail may have filled */
      if (nav._railSync) { nav._railSync(); return; }
      const wrapId = nav.getAttribute('data-rail-nav');
      const rail = document.getElementById(wrapId);
      if (!rail) return;
      const prev = nav.querySelector('[data-rail-prev]');
      const next = nav.querySelector('[data-rail-next]');
      const step = () => rail.clientWidth * 0.8;
      function sync() {
        if (prev) prev.disabled = rail.scrollLeft <= 4;
        if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
      rail.addEventListener('scroll', sync, { passive: true });
      nav._railSync = sync;
      sync();
    });
  }

  /* ---------- pill tabs ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-pill]');
    if (!b) return;
    const group = b.closest('[data-pill-group]');
    if (!group) return;
    $$('[data-pill]', group).forEach((x) => x.classList.remove('is-on'));
    b.classList.add('is-on');
    $$('[data-pane]', group).forEach((p) => p.classList.toggle('is-on', p.dataset.pane === b.dataset.pill));
  });

  /* ---------- club directory filter ---------- */
  function initClubFilter() {
    const input = $('#ClubSearch');
    if (!input) return;
    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase();
      $$('[data-club]').forEach((el) => {
        el.style.display = !q || el.dataset.club.toLowerCase().indexOf(q) > -1 ? '' : 'none';
      });
    });
  }

  /* ---------- solid header on scroll ---------- */
  function initHeaderScroll() {
    const h = document.querySelector('.hdr--over');
    if (!h) return;
    const onScroll = () => h.classList.toggle('is-solid', window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }


  /* ================= QUICK ADD WITH SIZE PICKER (Gymshark pattern) ================= */
  const productCache = {};
  function getProduct(handle){
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', {headers:{Accept:'application/json'}})
      .then(r => r.json()).then(d => { productCache[handle] = d; return d; });
  }



  function addCloseControl(box, card){
    if (box.querySelector('.qa-close')) return;
    const row = box.querySelector('.qa-sizes');
    if (!row) return;
    const b = document.createElement('button');
    b.className = 'qa-close';
    b.setAttribute('aria-label', 'Close size picker');
    b.innerHTML = '&times;';
    b.addEventListener('click', (ev) => {
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
      closeQuickAdd();
    });
    row.appendChild(b);
  }

  function bindOverlay(box, card){
    $$('button[data-add-variant]', box).forEach(b => {
      b.addEventListener('click', (ev) => {
        ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
        if (b.disabled) return;
        const label = b.textContent;
        b.textContent = '\u00b7\u00b7\u00b7';
        addToCart(b.getAttribute('data-add-variant'), 1).then(res => {
          b.textContent = label;
          closeQuickAdd();
          if (!res.ok) { toast((res.data && res.data.description) || 'Could not add to bag'); return; }
          toast('Added to bag');
          refreshCart(true);
        }).catch(() => { b.textContent = label; toast('Could not add to bag'); });
      });
      b.addEventListener('mousedown', ev => ev.preventDefault());
    });
    box.addEventListener('click', ev => ev.stopPropagation());
  }

  function closeQuickAdd(){
    $$('.qa-overlay').forEach(o => o.remove());
    $$('.pcard.qa-open').forEach(c => c.classList.remove('qa-open'));
  }

  function openQuickAdd(card, handle, auto, mode, pdpUrl){
    closeQuickAdd();
    const media = card.querySelector('.pcard__media');
    if (!media) return;
    if (!auto) card.classList.add('qa-open');
    const box = document.createElement('div');
    box.className = 'qa-overlay';
    if (auto) box.dataset.auto = '1';
    box.innerHTML = '<div class="qa-spinner">' + t('products.product.loading_options', 'Loading options...') + '</div>';
    media.appendChild(box);
    requestAnimationFrame(() => box.classList.add('is-open'));

    getProduct(handle).then(p => {
      /* locate the colour and size options by name */
      let colourIdx = -1, sizeIdx = -1;
      (p.options || []).forEach((o, i) => {
        const n = (typeof o === 'string' ? o : (o.name || '')).toLowerCase();
        if (n.indexOf('colour') > -1 || n.indexOf('color') > -1) colourIdx = i;
        if (n.indexOf('size') > -1) sizeIdx = i;
      });

      /* which colour is showing on this card */
      let colour = card.dataset.colour || '';
      if (!colour && colourIdx > -1) {
        const active = card.querySelector('.swatch.is-active[data-color]');
        if (active) colour = active.getAttribute('data-color');
      }

      /* only the variants in that colour */
      let pool = p.variants;
      if (colourIdx > -1 && colour) {
        const match = p.variants.filter(v => (v.options[colourIdx] || '') === colour);
        if (match.length) pool = match;
      }

      let items;
      if (sizeIdx === -1) {
        /* no size option: the colour itself is the variant */
        items = pool.map(v => ({ label: v.title, id: v.id, available: v.available }));
      } else {
        const seen = {};
        items = [];
        pool.forEach(v => {
          const label = v.options[sizeIdx];
          if (seen[label] === undefined) {
            seen[label] = items.length;
            items.push({ label: label, id: v.id, available: v.available });
          } else if (v.available && !items[seen[label]].available) {
            items[seen[label]] = { label: label, id: v.id, available: true };
          }
        });
      }

      const heading = (colourIdx > -1 && colour)
        ? '<div class="qa-colour">' + colour + '</div>' : '';

      /* P0-PDP-002: in 'select' mode a size opens the PDP at that variant so
         required configuration cannot be skipped. Nothing is added here. */
      const selectMode = mode === 'select';
      const html = heading +
        '<div class="qa-sizes">' +
          items.map(i => {
            const label = i.label;
            if (!i.available) {
              return '<button disabled aria-label="' + t('products.product.sold_out', 'Sold out') + ': ' + label + '">' + label + '</button>';
            }
            if (selectMode) {
              const href = (pdpUrl || '') + '?variant=' + i.id;
              return '<a href="' + href + '" aria-label="' + t('products.product.choose_options', 'Choose options') + ': ' + label + '">' + label + '</a>';
            }
            return '<button data-add-variant="' + i.id + '" aria-label="' + t('products.product.add_to_cart', 'Add to bag') + ': ' + label + '">' + label + '</button>';
          }).join('') +
        '</div>';
      box.innerHTML = html;
      bindOverlay(box, card);
      if (!auto) addCloseControl(box, card);
    }).catch(() => {
      box.innerHTML = '<div class="qa-spinner">' + t('products.product.options_error', 'Could not load options.') +
        ' <a href="' + (pdpUrl || '') + '" style="text-decoration:underline">' + t('products.product.view_product', 'View product') + '</a></div>';
    });
  }

  /* ================= PLP: grid density + filter sheet ================= */
  function initPlp(){
    const grid = $('#ProductGrid');
    if (grid) {
      let dens = null;
      try { dens = localStorage.getItem('bh_grid'); } catch(e){}
      if (dens === 'one') grid.classList.add('is-one');
      $$('[data-grid]').forEach(b => {
        b.classList.toggle('is-on', (b.dataset.grid === 'one') === grid.classList.contains('is-one'));
        b.addEventListener('click', () => {
          const one = b.dataset.grid === 'one';
          grid.classList.toggle('is-one', one);
          $$('[data-grid]').forEach(x => x.classList.toggle('is-on', x === b));
          try { localStorage.setItem('bh_grid', one ? 'one' : 'two'); } catch(e){}
        });
      });
    }
    $$('.fgroup__head').forEach(h => {
      h.addEventListener('click', () => {
        const body = h.nextElementSibling;
        if (!body) return;
        const open = body.hasAttribute('hidden');
        if (open) body.removeAttribute('hidden'); else body.setAttribute('hidden','');
        const s = h.querySelector('span:last-child');
        if (s) s.textContent = open ? '\u2212' : '+';
      });
    });
  }

  /* ================= sheets & modals ================= */
  function openSheet(id){
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    if (scrim){ scrim.hidden = false; scrim.classList.add('is-open'); }
    document.body.style.overflow = 'hidden';
  }
  function closeSheets(){
    $$('.sheet').forEach(s => s.classList.remove('is-open'));
    $$('.modal').forEach(m => m.classList.remove('is-open'));
    if (!$('.drawer.is-open')) {
      if (scrim){ scrim.classList.remove('is-open'); setTimeout(()=>{ if(!$('.drawer.is-open') && !$('.sheet.is-open')) scrim.hidden = true; },260); }
      document.body.style.overflow = '';
    }
  }
  window.bhOpenSheet = openSheet;

  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-sheet-open]');
    if (o){ e.preventDefault(); openSheet(o.getAttribute('data-sheet-open')); return; }
    const m = e.target.closest('[data-modal-open]');
    if (m){
      e.preventDefault();
      const el = document.getElementById(m.getAttribute('data-modal-open'));
      if (el){ el.classList.add('is-open'); document.body.style.overflow='hidden'; }
      return;
    }
    if (e.target.closest('[data-sheet-close]') || e.target.closest('[data-modal-close]')) { closeSheets(); return; }
    if (e.target.classList && e.target.classList.contains('modal')) closeSheets();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeSheets(); closeQuickAdd(); } });

  /* ================= PDP gallery: dots + zoom ================= */
  function initGallery(){
    const track = $('#GalTrack');
    if (!track) return;
    const slides = $$('.gal__slide', track);
    const dots = $$('#GalDots button');
    const counter = $('#GalCount');
    function sync(){
      const i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, n) => d.classList.toggle('is-on', n === i));
      if (counter) counter.textContent = (i + 1) + '/' + slides.length;
    }
    track.addEventListener('scroll', sync, { passive: true });
    dots.forEach((d, n) => d.addEventListener('click', () => {
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
    }));
    sync();

  }

  /* ================= PRODUCT VIEW =================
     One large picture: the front of the chosen colour, its back on hover
     (or from the Front / Back switch on a touch screen). The colour to
     picture map is written by the section; a colour change arrives as a
     bh:variant event from the option picker.

     A new picture is loaded off-screen before it is swapped in, so choosing
     a colour never flashes a half-drawn image.
     ================================================ */
  function initProductView(){
    const view = $('[data-pdp-view]');
    if (!view || view.dataset.viewReady) return;
    view.dataset.viewReady = '1';
    let map = {};
    try { map = JSON.parse(($('[data-pdpv-map]', view) || {}).textContent || '{}'); } catch (e) { return; }
    const front = $('.pdpv__front', view);
    const back = $('.pdpv__back', view);
    const pos = parseInt(view.dataset.colourPos || '0', 10) || 0;
    const sides = $$('[data-pdpv-side]', view);
    if (!front || !back) return;

    function side(which){
      const toBack = which === 'back' && view.classList.contains('pdpv--has-back');
      view.classList.toggle('is-back', toBack);
      sides.forEach((b) => b.setAttribute('aria-pressed', String((b.dataset.pdpvSide === 'back') === toBack)));
    }

    /* each picture remembers the file it is waiting for, so a quick run
       through the colours ends on the last one picked, not the slowest */
    function put(img, d){
      if (!d) { img.dataset.want = ''; img.hidden = true; img.removeAttribute('src'); return; }
      img.dataset.want = d.src;
      if (img.getAttribute('src') === d.src) { img.hidden = false; return; }
      const pre = new Image();
      pre.onload = pre.onerror = () => {
        if (img.dataset.want !== d.src) return;
        img.src = d.src; img.dataset.full = d.full; img.alt = d.alt || '';
        img.hidden = false;
      };
      pre.src = d.src;
    }

    function showColour(val){
      const entry = map[val] || map[Object.keys(map)[0]];
      if (!entry) return;
      side('front');
      view.classList.toggle('pdpv--has-back', !!entry.back);
      put(front, entry.front);
      put(back, entry.back);
    }

    view.addEventListener('click', (e) => {
      const b = e.target.closest('[data-pdpv-side]');
      if (b) side(b.dataset.pdpvSide);
    });

    document.addEventListener('bh:variant', (e) => {
      const v = e.detail;
      if (!v) return;
      showColour(pos ? v['option' + pos] : '_');
    });
  }

  /* ================= RETAIL LOCATIONS =================
     Hovering a row swaps the background. On a touch screen there is no
     hover, so the first tap activates a row and a second tap on the same row
     opens it - which is why the anchor's default has to be suppressed until
     the row is already the active one.

     Backgrounds are pre-rendered layers crossfaded by opacity rather than one
     element whose src is rewritten, so a swap never shows a half-loaded
     picture. Without script the rows stay ordinary links.
     ===================================================== */
  /* ---------------- background tone ----------------
     The transparent header floats on whatever photograph is showing, and on
     the stores list that photograph changes as the visitor moves down it.
     White type disappears on a pale picture, so the strip the bar actually
     covers gets measured and the header is told which way to go.

     Measured on a downscaled copy. Shopify will serve a 64px wide version of
     the same file from the same URL, which is a few hundred bytes and has
     averaged the detail away already. If the image is cross-origin and the
     canvas comes back tainted, the reading is abandoned and the header keeps
     the colour it had - a wrong guess is worse than no guess. */

  const toneCache = new Map();

  function readTone(src, veilAt, done) {
    if (!src) return;
    if (toneCache.has(src)) { done(toneCache.get(src)); return; }

    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onerror = () => { toneCache.set(src, null); done(null); };
    img.onload = () => {
      let light = null;
      try {
        const W = 48, H = 8;
        const c = document.createElement('canvas');
        c.width = W; c.height = H;
        const ctx = c.getContext('2d', { willReadFrequently: true });
        /* only the top of the picture: the part the bar sits on */
        ctx.drawImage(img, 0, 0, img.naturalWidth, Math.max(1, Math.round(img.naturalHeight / 8)), 0, 0, W, H);
        const d = ctx.getImageData(0, 0, W, H).data;
        let sum = 0;
        for (let x = 0; x < W; x++) {
          /* the section lays a black wash over the picture, and it is not
             even across the width, so the darkening is taken off column by
             column rather than judging the bare photograph */
          const keep = 1 - veilAt(x / (W - 1));
          for (let y = 0; y < H; y++) {
            const i = (y * W + x) * 4;
            sum += (0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]) / 255 * keep;
          }
        }
        /* 0.46 is where black type starts to out-contrast white on a flat
           colour of that brightness; nudged up a little because a photograph
           has bright spots that white type survives and black does not */
        light = (sum / (W * H)) > 0.5;
      } catch (e) {
        light = null;
      }
      toneCache.set(src, light);
      done(light);
    };
    /* the CDN will size it down for us; anything else is fetched as it is */
    img.src = src.replace(/([?&]width=)\d+/, '$164');
  }

  /* the layer behind everything: the section's own default picture */
  const BASE = 'base';

  function initRetail() {
    $$('[data-retail]').forEach((sec) => {
      if (sec.dataset.retailReady) return;
      sec.dataset.retailReady = '1';

      const rows = $$('[data-retail-row]', sec);
      const layers = $$('[data-retail-layer]', sec);
      if (!rows.length) return;

      const canHover = window.matchMedia && window.matchMedia('(any-hover: hover)').matches;
      let activeId = null;

      /* the veil is a left-to-right gradient of black, matching the
         background shorthand on .retail__veil */
      const veil = parseFloat(getComputedStyle(sec).getPropertyValue('--retail-veil')) || 0.55;
      const veilAt = (t) => (t <= 0.55
        ? (veil + 0.18) + (veil - (veil + 0.18)) * (t / 0.55)
        : veil + (veil * 0.6 - veil) * ((t - 0.55) / 0.45));

      function tellHeader(layer) {
        const hdr = document.querySelector('.hdr--over');
        if (!hdr || !layer) return;
        const src = layer.currentSrc || layer.src;
        const forId = activeId;
        readTone(src, veilAt, (light) => {
          /* a quick run down the list can land answers out of order */
          if (light === null || forId !== activeId) return;
          hdr.classList.toggle('is-light', light);
        });
      }

      function activate(id) {
        if (id === activeId) return;
        activeId = id;
        let shown = null;
        layers.forEach((l) => {
          const on = l.dataset.retailLayer === id;
          l.classList.toggle('is-on', on);
          if (on) shown = l;
        });
        /* a location with no image of its own falls back to the default */
        if (!shown) {
          const base = layers.find((l) => l.dataset.retailLayer === BASE);
          if (base) { base.classList.add('is-on'); shown = base; }
        }
        rows.forEach((r) => r.classList.toggle('is-active', r.dataset.retailRow === id));
        tellHeader(shown);
      }

      rows.forEach((row) => {
        const id = row.dataset.retailRow;
        if (canHover) {
          row.addEventListener('mouseenter', () => activate(id));
          row.addEventListener('focus', () => activate(id));
        } else {
          row.addEventListener('click', (e) => {
            /* first tap previews, second tap follows the link */
            if (activeId !== id) {
              e.preventDefault();
              activate(id);
            }
          });
        }
      });

      /* Off the list, the default picture. A store's own picture belongs to
         the moment it is being pointed at, so leaving the list hands the
         stage back rather than stranding it on whoever was last hovered. */
      if (canHover) {
        const list = $('.retail__list', sec) || sec;
        list.addEventListener('mouseleave', () => activate(BASE));
        list.addEventListener('focusout', (e) => {
          if (!list.contains(e.relatedTarget)) activate(BASE);
        });
      }

      /* nothing is being pointed at yet, so the page opens on the default */
      activate(BASE);
    });
  }

  /* ================= STORE HOURS =================
     Marks today's row from the visitor's own clock. Storing a timezone per
     store would be more precise and much easier to get wrong; this is a
     reading aid, not a claim about whether the door is open.
     ================================================ */
  function initStoreHours() {
    const card = $('[data-store-card]');
    if (!card) return;
    const days = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
    const today = days[new Date().getDay()];
    $$('.store__hour', card).forEach((row) => {
      const d = (row.dataset.day || '').toLowerCase();
      /* matches "monday" and also "monday - friday" style ranges */
      if (d === today || d.indexOf(today) === 0) row.classList.add('is-today');
    });
  }

  /* ================= IMAGE ZOOM VIEWER =================
     One dialog for every gallery on the site. Opens fitted to the screen,
     then wheel or pinch to zoom about the pointer, drag to pan, double click
     to toggle, buttons and keys for everything else.

     The image is sized in real pixels and moved with a transform rather than
     being letterboxed by object-fit, which is what made the old one a dead
     end: it could never be larger than the window, so there was nothing to
     scroll to and no way to look closer. Panning is clamped to the picture's
     own edges so it cannot be thrown off screen and lost.
     ===================================================== */
  function initZoom(){
    const box = $('#Zoom');
    if (!box || box.dataset.zoomReady) return;
    box.dataset.zoomReady = '1';

    const stage = $('#ZoomStage', box);
    const img   = $('#ZoomImg', box);
    const level = $('#ZoomLevel', box);
    if (!stage || !img) return;

    const MIN = 1, MAX = 6;
    let scale = 1, tx = 0, ty = 0;
    let baseW = 0, baseH = 0;              /* size at scale 1, fitted to the stage */
    let dragging = false, moved = false, lastX = 0, lastY = 0;
    const pointers = new Map();
    let pinchDist = 0, pinchFrom = 1;

    const isOpen = () => box.classList.contains('is-open');

    function measure(){
      const r = stage.getBoundingClientRect();
      const nw = img.naturalWidth, nh = img.naturalHeight;
      if (!nw || !nh || !r.width || !r.height) return;
      const fit = Math.min(r.width / nw, r.height / nh);
      baseW = nw * fit; baseH = nh * fit;
      img.style.width = baseW + 'px';
      img.style.height = baseH + 'px';
    }

    function apply(){
      const r = stage.getBoundingClientRect();
      const maxX = Math.max(0, (baseW * scale - r.width) / 2);
      const maxY = Math.max(0, (baseH * scale - r.height) / 2);
      tx = Math.min(maxX, Math.max(-maxX, tx));
      ty = Math.min(maxY, Math.max(-maxY, ty));
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      box.classList.toggle('is-zoomed', scale > 1.01);
      if (level) level.textContent = Math.round(scale * 100) + '%';
    }

    /* zoom about a point on screen, so whatever is under the cursor or
       between the fingers stays under it */
    function zoomTo(next, cx, cy){
      next = Math.min(MAX, Math.max(MIN, next));
      const r = stage.getBoundingClientRect();
      const ox = r.left + r.width / 2, oy = r.top + r.height / 2;
      const px = (cx === undefined ? ox : cx) - ox;
      const py = (cy === undefined ? oy : cy) - oy;
      tx = px - (px - tx) * (next / scale);
      ty = py - (py - ty) * (next / scale);
      scale = next;
      apply();
    }

    function reset(){ scale = 1; tx = 0; ty = 0; measure(); apply(); }

    function open(src, alt){
      img.style.width = ''; img.style.height = '';
      img.src = src;
      img.alt = alt || '';
      box.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (img.complete && img.naturalWidth) reset();
      else img.addEventListener('load', reset, { once: true });
    }

    function close(){
      box.classList.remove('is-open', 'is-zoomed');
      document.body.style.overflow = '';
    }

    /* Front / Back for a picture with two sides - the product view */
    const sidesBar = $('[data-zoom-sides]', box);
    let sides = null, sideAt = 0;
    function showSides(list, at){
      sides = list; sideAt = at || 0;
      if (!sidesBar) return;
      sidesBar.hidden = !sides;
      $$('[data-zoom-side]', sidesBar).forEach((b) =>
        b.setAttribute('aria-pressed', String(+b.dataset.zoomSide === sideAt)));
    }
    function goSide(n){
      if (!sides || !sides[n] || n === sideAt) return;
      open(sides[n].src, sides[n].alt);
      showSides(sides, n);
    }
    if (sidesBar) sidesBar.addEventListener('click', (e) => {
      const b = e.target.closest('[data-zoom-side]');
      if (b) goSide(+b.dataset.zoomSide);
    });

    const fullOf = (i) => ({ src: i.dataset.full || i.currentSrc || i.src, alt: i.alt });

    /* any gallery marked data-zoomable opens the viewer */
    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-zoomable] img');
      if (!t) return;
      e.preventDefault();
      open(t.dataset.full || t.currentSrc || t.src, t.alt);
      /* the product view: open on the side that was clicked, with the other
         one a button away */
      const view = t.closest('[data-pdp-view]');
      const f = view && view.querySelector('.pdpv__front');
      const bk = view && view.querySelector('.pdpv__back');
      if (f && bk && !bk.hidden && bk.getAttribute('src')) showSides([fullOf(f), fullOf(bk)], t === bk ? 1 : 0);
      else showSides(null);
    });

    box.addEventListener('click', (e) => {
      if (e.target.closest('[data-zoom-close]')) { close(); return; }
      if (e.target.closest('.zoom__tools')) return;
      /* the click that ends a drag must not also dismiss the viewer */
      if (moved) { moved = false; return; }
      /* Close only on the empty space around the picture. The stage covers
         the whole window so it is always the click target, which means the
         target alone cannot tell the two apart - and closing on any stage
         click would also fire on the first half of a double click and shut
         the viewer before the zoom could happen. Hit-testing the image's own
         box keeps double click free, with no timer to guess with. */
      const r = img.getBoundingClientRect();
      const inside = e.clientX >= r.left && e.clientX <= r.right &&
                     e.clientY >= r.top  && e.clientY <= r.bottom;
      if (inside) return;
      close();
    });

    document.addEventListener('keydown', (e) => {
      if (!isOpen()) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === '+' || e.key === '=') { e.preventDefault(); zoomTo(scale * 1.4); }
      else if (e.key === '-' || e.key === '_') { e.preventDefault(); zoomTo(scale / 1.4); }
      else if (e.key === '0') { e.preventDefault(); reset(); }
      else if (sides && e.key === 'ArrowLeft') { e.preventDefault(); goSide(0); }
      else if (sides && e.key === 'ArrowRight') { e.preventDefault(); goSide(1); }
    });

    $$('[data-zoom-step]', box).forEach(b => b.addEventListener('click', () => {
      zoomTo(b.getAttribute('data-zoom-step') > 0 ? scale * 1.4 : scale / 1.4);
    }));
    const rst = $('[data-zoom-reset]', box);
    if (rst) rst.addEventListener('click', reset);

    stage.addEventListener('wheel', (e) => {
      e.preventDefault();
      zoomTo(scale * (e.deltaY < 0 ? 1.14 : 1 / 1.14), e.clientX, e.clientY);
    }, { passive: false });

    stage.addEventListener('dblclick', (e) => {
      e.preventDefault();
      if (scale > 1.01) reset(); else zoomTo(2.5, e.clientX, e.clientY);
    });

    stage.addEventListener('pointerdown', (e) => {
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 2) {
        const pts = Array.from(pointers.values());
        pinchDist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        pinchFrom = scale;
        dragging = false;
        return;
      }
      dragging = true; moved = false;
      lastX = e.clientX; lastY = e.clientY;
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    });

    stage.addEventListener('pointermove', (e) => {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (pointers.size === 2) {
        const pts = Array.from(pointers.values());
        const d = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        if (pinchDist > 0) {
          zoomTo(pinchFrom * (d / pinchDist), (pts[0].x + pts[1].x) / 2, (pts[0].y + pts[1].y) / 2);
        }
        moved = true;
        return;
      }
      if (!dragging) return;
      const dx = e.clientX - lastX, dy = e.clientY - lastY;
      if (Math.abs(dx) > 2 || Math.abs(dy) > 2) moved = true;
      lastX = e.clientX; lastY = e.clientY;
      tx += dx; ty += dy;
      apply();
    });

    const endPointer = (e) => {
      pointers.delete(e.pointerId);
      if (pointers.size < 2) pinchDist = 0;
      if (pointers.size === 0) dragging = false;
    };
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);

    window.addEventListener('resize', () => { if (isOpen()) { measure(); apply(); } });
  }

  /* ================= mobile menu slide-in panels ================= */
  function initMobilePanels(){
    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-panel-open]');
      if (t){
        e.preventDefault();
        const p = document.getElementById(t.getAttribute('data-panel-open'));
        if (p) p.classList.add('is-open');
        return;
      }
      const b = e.target.closest('[data-panel-back]');
      if (b){ e.preventDefault(); const p = b.closest('.mpanel'); if (p) p.classList.remove('is-open'); return; }
      if (e.target.closest('.mpanel a')) closeDrawers();
    });
  }

  /* ================= newsletter popup ================= */
  /* ---------------- welcome popup ----------------
     Remembered per campaign (data-key), so renaming the campaign in the
     theme editor shows the new popup once to everyone.

     A sign-up reloads the page. The popup used to mark itself seen when it
     opened, so it stayed shut after the reload and its thank-you - and any
     code in it - was never shown. It now notes the submit and reopens once
     to show whatever Shopify sent back, success or error. */
  const POP_SIGNED = 'bh_pop_signed';     /* localStorage: subscribed, never again */
  const POP_JUST = 'bh_pop_just_posted';  /* sessionStorage: reopen after the reload */
  function popStore(session){
    try { return session ? window.sessionStorage : window.localStorage; } catch(e){ return null; }
  }
  function popGet(k, session){ const s = popStore(session); try { return s ? s.getItem(k) : null; } catch(e){ return null; } }
  function popSet(k, v, session){ const s = popStore(session); try { if (s) s.setItem(k, v); } catch(e){} }
  function popDel(k, session){ const s = popStore(session); try { if (s) s.removeItem(k); } catch(e){} }

  let popReturnFocus = null;
  function popOpen(pop){
    if (pop.classList.contains('is-open')) return;
    popReturnFocus = document.activeElement;
    pop.classList.add('is-open');
    const target = pop.querySelector('input[type="email"]') || pop.querySelector('.pop__close');
    if (target) setTimeout(() => { try { target.focus({ preventScroll: true }); } catch(e){} }, 60);
  }
  function popClose(pop){
    if (!pop.classList.contains('is-open')) return;
    pop.classList.remove('is-open');
    if (popReturnFocus && popReturnFocus.focus) { try { popReturnFocus.focus({ preventScroll: true }); } catch(e){} }
  }

  let popEditorBound = false;
  function initPopup(){
    const pop = $('#NewsPop');
    if (!popEditorBound) {
      popEditorBound = true;
      /* in the theme editor the popup opens while its section is selected,
         and again after each edit re-renders it, so changes show live */
      const mine = (e) => e.target && e.target.querySelector && e.target.querySelector('#NewsPop');
      document.addEventListener('shopify:section:select', (e) => { const p = mine(e); if (p) popOpen(p); });
      document.addEventListener('shopify:section:load', (e) => { const p = mine(e); if (p) popOpen(p); });
      document.addEventListener('shopify:section:deselect', (e) => { const p = mine(e); if (p) popClose(p); });
      /* bubble phase on the document, so it runs after the spam guard on
         the form and sees whether the guard stopped the submit */
      document.addEventListener('submit', (e) => {
        if (e.defaultPrevented || !e.target.closest || !e.target.closest('#NewsPop')) return;
        popSet(POP_JUST, '1', true);
      });
      document.addEventListener('keydown', (e) => {
        const p = $('#NewsPop');
        if (e.key === 'Escape' && p) popClose(p);
      });
    }
    if (!pop || pop.dataset.popBound) return;
    pop.dataset.popBound = '1';

    pop.addEventListener('click', (e) => {
      if (e.target === pop || e.target.closest('.pop__close') || e.target.closest('[data-pop-dismiss]')) popClose(pop);
    });

    /* the reload after a sign-up: show the outcome once */
    if (popGet(POP_JUST, true)) {
      popDel(POP_JUST, true);
      if (pop.querySelector('.success')) popSet(POP_SIGNED, '1');
      popOpen(pop);
      return;
    }

    if (pop.dataset.editor === '1') return;   /* the editor events above drive it */
    if (popGet(POP_SIGNED)) return;

    const key = pop.dataset.key || 'bh_pop';
    const days = parseInt(pop.dataset.days || '0', 10) || 0;
    const last = parseInt(popGet(key) || '0', 10) || 0;
    if (last) {
      if (!days) return;
      if (Date.now() - last < days * 864e5) return;
    }
    if (pop.dataset.mobile !== '1' && window.matchMedia('(max-width: 749px)').matches) return;

    let fired = false;
    const cleanup = [];
    const show = () => {
      if (fired) return;
      fired = true;
      cleanup.forEach((fn) => fn());
      popSet(key, String(Date.now()));
      popOpen(pop);
    };

    const delay = Math.max(0, parseInt(pop.dataset.delay || '8', 10) || 0);
    const t = setTimeout(show, delay ? delay * 1000 : 400);
    cleanup.push(() => clearTimeout(t));

    const pct = parseInt(pop.dataset.scroll || '0', 10) || 0;
    if (pct > 0) {
      const onScroll = () => {
        const room = document.documentElement.scrollHeight - window.innerHeight;
        if (room > 0 && window.scrollY / room >= pct / 100) show();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      cleanup.push(() => window.removeEventListener('scroll', onScroll));
    }

    if (pop.dataset.exit === '1' && window.matchMedia('(pointer: fine)').matches) {
      const onOut = (e) => { if (!e.relatedTarget && e.clientY <= 0) show(); };
      document.addEventListener('mouseout', onOut);
      cleanup.push(() => document.removeEventListener('mouseout', onOut));
    }
  }







  /* PDP share + learn-more jump */
  document.addEventListener('click', (e) => {
    const sh = e.target.closest('[data-share]');
    if (sh) {
      e.preventDefault();
      const data = { title: document.title, url: location.href };
      if (navigator.share) { navigator.share(data).catch(() => {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(location.href); toast('Link copied'); }
      return;
    }
    const jm = e.target.closest('[data-jump-desc]');
    if (jm) {
      e.preventDefault();
      const acc = document.querySelector('.acc__item');
      if (acc) {
        acc.classList.add('is-open');
        acc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  });




  /* ================= MARQUEE =================
     A seamless loop needs the track duplicated so the -50% keyframe lands
     on an identical frame. Idempotent and Theme-Editor safe: guarded per
     element, teardown on section unload, and skipped under reduced motion.
     =========================================== */
  function initMarquee(root){
    const scope = root || document;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    $$('.sect--scroll-marquee', scope).forEach((sec) => {
      const track = sec.querySelector('.prail, .cgrid, .tiles, .feat3, .tcards');
      if (!track || track.dataset.mq === '1') return;

      const items = Array.from(track.children);
      if (items.length < 2) return;            /* nothing to loop */

      /* wrap once so overflow + mask apply to a stable parent */
      if (!track.parentElement.classList.contains('mq-viewport')) {
        const vp = document.createElement('div');
        vp.className = 'mq-viewport';
        track.parentElement.insertBefore(vp, track);
        vp.appendChild(track);
      }

      /* duplicate the set; clones are inert and hidden from assistive tech */
      items.forEach((el) => {
        const clone = el.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.mqClone = '1';
        clone.querySelectorAll('a,button,input,select,textarea').forEach((f) => {
          f.setAttribute('tabindex', '-1');
        });
        track.appendChild(clone);
      });
      track.dataset.mq = '1';
    });
  }

  function teardownMarquee(root){
    $$('.sect--scroll-marquee', root || document).forEach((sec) => {
      const track = sec.querySelector('[data-mq="1"]');
      if (!track) return;
      $$('[data-mq-clone]', track).forEach((c) => c.remove());
      delete track.dataset.mq;
    });
  }

  /* ================= MEGA MENU INTENT =================
     Opening is instant. Closing waits, so moving diagonally toward
     the panel, or briefly clipping the edge, does not dismiss it.
     ===================================================== */
  function initMegaMenu(){
    const items = $$('.has-mega');
    if (!items.length) return;
    let closeTimer;

    function openOne(li){
      clearTimeout(closeTimer);
      items.forEach(x => { if (x !== li) x.classList.remove('is-open'); });
      li.classList.add('is-open');
    }
    function scheduleClose(){
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        items.forEach(x => x.classList.remove('is-open'));
      }, 260);
    }

    items.forEach(li => {
      li.addEventListener('mouseenter', () => openOne(li));
      li.addEventListener('mouseleave', scheduleClose);

      /* keyboard: open on focus, close when focus leaves the item */
      li.addEventListener('focusin', () => openOne(li));
      li.addEventListener('focusout', (e) => {
        if (!li.contains(e.relatedTarget)) scheduleClose();
      });
    });

    /* leaving the header area closes everything */
    const hdr = $('.hdr');
    if (hdr) {
      hdr.addEventListener('mouseleave', scheduleClose);
      hdr.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') items.forEach(x => x.classList.remove('is-open'));
    });
    window.addEventListener('scroll', () => {
      items.forEach(x => x.classList.remove('is-open'));
    }, { passive: true });
  }

  /* ================= CART DRAWER: TABS, WISHLIST, EXTRAS ================= */
  function switchCartTab(name){
    $$('[data-cart-tab]').forEach(b => {
      const on = b.dataset.cartTab === name;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    $$('[data-cart-pane]').forEach(p => p.classList.toggle('is-on', p.dataset.cartPane === name));
    if (name === 'wish') renderWishlist();
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-cart-tab]');
    if (t) { e.preventDefault(); switchCartTab(t.dataset.cartTab); }
  });

  /* ---- wishlist panel ---- */
  function renderWishlist(){
    const host = $('#WishItems');
    if (!host) return;
    const list = wishGet();
    const badge = $('#WishTabCount');
    if (badge) { badge.textContent = list.length; badge.style.display = list.length ? '' : 'none'; }

    if (!list.length) {
      host.innerHTML = '<div class="cart-empty"><p>Nothing saved yet.</p>' +
        '<p class="cartd__fine">Tap the heart on any product to save it here.</p></div>';
      return;
    }
    host.innerHTML = '<div class="cart-empty"><p>Loading\u2026</p></div>';

    Promise.all(list.map(h =>
      fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(r => r.ok ? r.json() : null).catch(() => null)
    )).then(items => {
      const good = items.filter(Boolean);
      if (!good.length) { host.innerHTML = '<div class="cart-empty"><p>Nothing saved yet.</p></div>'; return; }
      host.innerHTML = good.map(p => {
        const img = p.featured_image ? sized(p.featured_image, 200) : '';
        const one = p.variants.length === 1 && p.variants[0].available;
        const sold = !p.available;
        return '<div class="citem" data-wish="' + p.handle + '">' +
          (img ? '<img class="citem__img" src="' + img + '" alt="' + attr(p.title) + '" width="80" height="100" loading="eager" decoding="async">' : '<div class="citem__img"></div>') +
          '<div style="flex:1;min-width:0">' +
            '<a href="' + p.url + '"><div class="citem__title">' + p.title + '</div></a>' +
            '<div class="citem__meta">' + (sold ? 'Sold out' : money(p.price)) + '</div>' +
            '<div class="citem__acts">' +
              (sold ? '<span class="citem__soldout">Sold out</span>'
                    : '<a class="citem__move" href="' + p.url + '">' + t('products.product.choose_options', 'Choose options') + '</a>') +
              '<button class="citem__remove" data-wish-remove="' + p.handle + '">Remove</button>' +
            '</div>' +
          '</div></div>';
      }).join('');
    });
  }

  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-wish-remove]');
    if (rm) {
      e.preventDefault();
      const h = rm.getAttribute('data-wish-remove');
      wishSet(wishGet().filter(x => x !== h));
      paintWish(); renderWishlist(); toast('Removed from wishlist');
      return;
    }
    /* move an item from the bag to the wishlist */
    const mv = e.target.closest('[data-move-wish]');
    if (mv) {
      e.preventDefault();
      const row = mv.closest('.citem');
      const handle = mv.getAttribute('data-move-wish');
      const list = wishGet();
      if (list.indexOf(handle) === -1) { list.unshift(handle); wishSet(list); }
      paintWish();
      if (row) changeLine(row.dataset.key, 0).then(renderCart);
      toast('Moved to wishlist');
    }
  });

  /* ---- discount code ---- */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('#DiscountApply')) return;
    e.preventDefault();
    const f = $('#DiscountCode');
    const code = (f && f.value || '').trim();
    if (!code) { toast('Enter a code first'); return; }
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrls.cart);
  });

  /* ================= CART ADD-ONS ================= */
  let upsellFor = null;
  function loadUpsell(cart){
    const host = $('#CartUpsell');
    if (!host || !(window.BH && BH.cartUpsell)) return;
    if (!cart || !cart.items.length) { host.innerHTML = ''; return; }

    const seed = cart.items[cart.items.length - 1];
    if (upsellFor === seed.product_id) return;      // already showing for this product
    upsellFor = seed.product_id;

    const inCart = cart.items.map(i => i.product_id);
    const base = (window.BH && BH.recUrl) || '/recommendations/products';
    const url = base + '?section_id=&product_id=' + seed.product_id + '&limit=6&intent=complementary';

    fetch(url.replace('section_id=&', '') + '&_=' + Date.now(), { headers: { Accept: 'application/json' } })
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (!d || !d.products) { host.innerHTML = ''; return; }
        const picks = d.products.filter(p => inCart.indexOf(p.id) === -1 && p.available).slice(0, 4);
        if (!picks.length) { host.innerHTML = ''; return; }

        host.innerHTML =
          '<div class="upsell"><div class="upsell__head">' +
            ((window.BH && BH.upsellHeading) || 'Complete your kit') +
          '</div>' +
          picks.map(p => {
            const img = p.featured_image ? sized(p.featured_image, 150) : '';
            const one = p.variants.length === 1 && p.variants[0].available;
            return '<div class="upsell__row">' +
              /* alt="" on purpose - the title sits right beside it as a link */
              (img ? '<img src="' + img + '" alt="" width="60" height="75" loading="eager" decoding="async">' : '<div class="upsell__ph"></div>') +
              '<div class="upsell__info">' +
                '<a href="' + p.url + '">' + p.title + '</a>' +
                '<span>' + money(p.price) + '</span>' +
              '</div>' +
              /* P0-PDP-002: product JSON omits metafields, so configuration
                 status is unknown here. Fail closed and route to the PDP. */
              '<a class="upsell__add" href="' + p.url + '">' + t('products.product.choose_options', 'Choose options') + '</a>' +
            '</div>';
          }).join('') +
          '</div>';
      })
      .catch(() => { host.innerHTML = ''; });
  }





  /* ================= HOVER IMAGE PRELOAD =================
     The hover shot is lazy-loaded to save bandwidth. Fetch it the
     moment the pointer arrives so the swap never shows a blank frame.
     Also clears focus after a click so a card cannot stay stuck in
     its hover state.
     ======================================================== */
  function initHoverPreload(){
    $$('.pcard').forEach(card => {
      if (card._hoverBound) return;
      card._hoverBound = true;

      const hoverImg = card.querySelector('.pcard__img--hover');
      if (hoverImg) {
        const warm = () => {
          if (hoverImg.dataset.warm) return;
          hoverImg.dataset.warm = '1';
          hoverImg.setAttribute('loading', 'eager');
          if (hoverImg.decode) hoverImg.decode().catch(() => {});
        };
        card.addEventListener('pointerenter', warm, { once: true });
        card.addEventListener('touchstart', warm, { once: true, passive: true });
      }


      /* A hover shot that cannot load must not leave an empty layer.
         Check the current state as well as listening, because the image
         may already have failed before this script ran. */
      if (hoverImg) {
        const drop = () => {
          hoverImg.remove();
          card.classList.add('pcard--single');
        };
        if (hoverImg.complete && hoverImg.naturalWidth === 0) drop();
        else hoverImg.addEventListener('error', drop, { once: true });
        if (!hoverImg.getAttribute('src')) drop();
      }

      /* a tap leaves the link focused, which used to freeze the card */
      card.addEventListener('click', () => {
        const a = document.activeElement;
        if (a && card.contains(a) && a.blur) setTimeout(() => a.blur(), 0);
      });
    });
  }

  /* ================= COLOUR SELECTION ON CARDS =================
     Clicking a swatch picks that colour: the card image switches to it and
     the choice is remembered. The + then offers only the sizes that exist
     in that colour, and adding uses the exact colour + size variant.
     ============================================================= */
  function selectColour(card, sw){
    const colour = sw.getAttribute('data-color');
    card.dataset.colour = colour || '';
    card._colourLocked = true;

    $$('.swatch', card).forEach(x => x.classList.remove('is-active'));
    sw.classList.add('is-active');

    const img = sw.getAttribute('data-img');
    const base = card.querySelector('.pcard__img--main');
    if (img && base) {
      base.setAttribute('src', img);
      base.removeAttribute('srcset');
      /* The hover picture sits on top while the pointer is on the card, and
         choosing a dot means the pointer is on the card - so it has to change
         with the colour too, or the new colour stays hidden under the old
         colour's back until the mouse leaves. A colour with no back photo
         shows its front on hover. */
      const hover = card.querySelector('.pcard__img--hover');
      if (hover) {
        const back = sw.getAttribute('data-img-back');
        if (back) {
          hover.setAttribute('src', back);
          hover.removeAttribute('srcset');
        }
        card.classList.toggle('pcard--noback', !back);
      }
    }
    /* an open size panel must refresh for the new colour */
    if (card.querySelector('.qa-overlay')) {
      const btn = card.querySelector('[data-quick-add]');
      closeQuickAdd();
      if (btn) openQuickAdd(card, btn.getAttribute('data-handle'), false);
    }
  }

  document.addEventListener('click', (e) => {
    const sw = e.target.closest('.swatch[data-color]');
    if (!sw) return;
    e.preventDefault();
    e.stopPropagation();
    const card = sw.closest('.pcard');
    if (card) selectColour(card, sw);
  });

  /* ================= QUICK ADD: hover to reveal, tap to open =================
     Represent reveals sizes when you hover the + button.
     Gymshark reveals them when you hover the image.
     Both are supported. Listeners are bound directly to each element rather
     than delegated, so nothing else on the page can swallow the event.
     ========================================================================= */
  function initQuickAdd(){
    const canHover = !(window.matchMedia && window.matchMedia('(hover: none)').matches);

    $$('.pcard').forEach(card => {
      if (card._qaBound) return;
      card._qaBound = true;

      const btn = card.querySelector('[data-quick-add]');
      if (!btn) return;
      const handle = btn.getAttribute('data-handle');
      const mode = btn.getAttribute('data-qa-mode') || 'select';
      const pdpUrl = btn.getAttribute('data-url') || '';
      /* single-variant fast-add only exists when Liquid verified the product */
      const singleId = mode === 'add' ? btn.getAttribute('data-variant-id') : null;

      /* tap / click: never let it reach the card link, never scroll */
      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();
        if (btn.blur) btn.blur();

        if (singleId) {
          btn.classList.add('is-disabled');
          addToCart(singleId, 1).then(res => {
            btn.classList.remove('is-disabled');
            if (!res.ok) { toast((res.data && res.data.description) || 'Could not add to bag'); return; }
            toast('Added to bag');
            refreshCart(true);
          }).catch(() => btn.classList.remove('is-disabled'));
          return;
        }
        const open = card.querySelector('.qa-overlay');
        if (open) {
          if (open.dataset.auto === '1') {
            /* hover-opened: pin it so it survives the pointer leaving */
            open.dataset.auto = '0';
            addCloseControl(open, card);
          } else {
            closeQuickAdd();
          }
        } else {
          openQuickAdd(card, handle, false, mode, pdpUrl);
        }
      });

      /* also stop mousedown so the browser never moves focus or scrolls */
      btn.addEventListener('mousedown', (ev) => { ev.preventDefault(); ev.stopPropagation(); });
      btn.addEventListener('touchstart', (ev) => { ev.stopPropagation(); }, { passive: true });

      if (!canHover || !handle) return;

      let openT, closeT;
      const open = () => {
        clearTimeout(closeT);
        openT = setTimeout(() => {
          if (!card.querySelector('.qa-overlay')) openQuickAdd(card, handle, true, mode, pdpUrl);
        }, 140);
      };
      const shut = () => {
        clearTimeout(openT);
        closeT = setTimeout(() => {
          const box = card.querySelector('.qa-overlay');
          if (box && box.dataset.auto === '1') closeQuickAdd();
        }, 220);
      };

      /* Gymshark: hovering the image reveals sizes */
      card.addEventListener('mouseenter', open);
      card.addEventListener('mouseleave', shut);
      /* Represent: hovering the + reveals them too */
      btn.addEventListener('mouseenter', open);
    });
  }

  /* ================= BACKGROUND VIDEO: KEEP IT LOOPING =================
     Every background video already carries the loop attribute, but a looping
     video can still end up stopped: a browser suspends media in a background
     tab and does not always resume it, iOS drops playback when the page comes
     back from the back/forward cache, a stalled buffer fires pause, and a
     rejected autoplay promise leaves the element paused with no retry.

     This restarts any background video that is not playing when it should be.
     Videos with controls are left alone, since a paused one there is the
     viewer's own choice. */
  let videoLoopBound = false;
  let videoLoopIO = null;

  function kickVideo(v) {
    if (!v || !v.isConnected || v.hasAttribute('controls')) return;
    /* muted is what makes autoplay permissible at all; a video that lost it
       would be blocked from restarting silently */
    v.muted = true;
    v.loop = true;
    if (!v.paused && !v.ended) return;
    const p = v.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  }

  function initVideoLoop() {
    const vids = $$('video[autoplay]').filter(v => !v.hasAttribute('controls'));

    if (!videoLoopBound) {
      videoLoopBound = true;
      /* these re-query on fire, so sections reloaded later are covered too */
      const kickAll = () => $$('video[autoplay]').forEach(kickVideo);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) kickAll(); });
      window.addEventListener('pageshow', kickAll);
      window.addEventListener('focus', kickAll);
      if ('IntersectionObserver' in window) {
        videoLoopIO = new IntersectionObserver((entries) => {
          entries.forEach(en => { if (en.isIntersecting) kickVideo(en.target); });
        }, { threshold: 0.01 });
      }
    }

    vids.forEach((v) => {
      v.loop = true;
      v.setAttribute('loop', '');
      /* init() runs again on every section reload in the theme editor, so the
         per-element listeners are attached once and only once */
      if (!v.dataset.loopWatched) {
        v.dataset.loopWatched = '1';
        /* loop should make ended unreachable, but a source reporting a ragged
           duration can still fire it */
        v.addEventListener('ended', () => {
          try { v.currentTime = 0; } catch (e) {}
          kickVideo(v);
        });
        v.addEventListener('pause', () => { setTimeout(() => kickVideo(v), 60); });
        v.addEventListener('stalled', () => kickVideo(v));
        v.addEventListener('suspend', () => kickVideo(v));
        if (videoLoopIO) videoLoopIO.observe(v);
      }
      kickVideo(v);
    });
  }

  /* ---------------- video framing ----------------
     The editor's zoom and position sliders, made to work on both axes.

     CSS alone cannot do this. object-fit:cover scales the video until it
     covers the container, which leaves surplus on exactly one axis - the
     one where the video is proportionally longer than the box. On the other
     axis the video ends flush, there is no surplus, and the slider for that
     axis has nothing to move. A 16:9 video in a wide hero fills the width
     exactly, so up/down pans and left/right sits dead. Which axis goes dead
     depends on the video, so it cannot be predicted in a stylesheet.

     Here the real numbers are known - the container's size and the video's
     own dimensions - so the geometry can be worked out properly:

       - Pan across the natural surplus first. A wide video in a narrow box
         still pans edge to edge with no zoom added, exactly as before.
       - Only when a slider asks to travel further than the surplus allows
         does the video zoom in, and only by the smallest amount that opens
         up the room asked for. Centred sliders add nothing, so a video left
         alone looks exactly as it did.

     Expressed purely as a transform, never as width or height: the pop-up's
     container takes its height from the video's aspect-ratio box, and
     resizing the video itself would collapse it.

     Without JavaScript the CSS in the VIDEO FRAMING block still applies, so
     the sliders keep working on whichever axis has the surplus. */

  const FRAMED_VIDEO = ['.hero__media', '.ebnr__media', '.prlx__media', '.popup__media',
                        '.club-hero__media', '.gbanner__media', '.store__hero-media',
                        '.enqp__hero-media']
                        .map(s => s + ' video').join(',');

  /* The pan an axis with no surplus of its own is given at full slider
     travel, as a fraction of the container. A quarter is enough to be
     unmistakably moving without cropping the video hard. */
  const PAN_FLOOR = 0.25;

  let framingRO = null;

  function frameVideo(v) {
    const W = v.offsetWidth, H = v.offsetHeight;
    const vw = v.videoWidth, vh = v.videoHeight;
    /* metadata not in yet, or the section is hidden - the load handler and
       the resize observer both come back through here later */
    if (!W || !H || !vw || !vh) return;

    const cs = getComputedStyle(v);
    const num = (name, fallback) => {
      const n = parseFloat(cs.getPropertyValue(name));
      return isFinite(n) ? n : fallback;
    };
    const fit  = (cs.getPropertyValue('--video-fit') || '').trim() || 'cover';
    const zoom = num('--video-zoom', 1);
    const fx   = num('--video-x', 50) / 100;
    const fy   = num('--video-y', 50) / 100;

    /* The video as the browser paints it inside the element: scaled until it
       covers (or fits within), then cropped to the element's edges. Whatever
       spills past those edges is the surplus the sliders have to play with,
       and cover only ever spills on one axis. */
    const base = fit === 'contain' ? Math.min(W / vw, H / vh) : Math.max(W / vw, H / vh);
    const sx = Math.max(0, vw * base - W);
    const sy = Math.max(0, vh * base - H);

    /* Enough zoom to open up room on an axis that has none. Nothing is added
       while a slider sits at the centre, or while the surplus already covers
       the travel asked for, so a video nobody has touched is untouched. Fit
       is left alone throughout - showing the whole frame is its entire point,
       and growing it to feed a slider would undo that. */
    let k = zoom;
    if (fit !== 'contain') {
      const wantX = PAN_FLOOR * W * Math.abs(fx - 0.5) * 2;
      const wantY = PAN_FLOOR * H * Math.abs(fy - 0.5) * 2;
      k = Math.max(k, 1 + Math.max(0, wantX - sx) / W, 1 + Math.max(0, wantY - sy) / H);
    }

    /* Panning is object-position's job, not the transform's: cover has
       already cropped the video to the element's edges, so moving the
       element would slide that crop off the container and show what is
       behind it. object-position instead chooses which part of the video
       the crop keeps. */
    v.style.objectPosition = (fx * 100).toFixed(2) + '% ' + (fy * 100).toFixed(2) + '%';

    /* The zoom is the transform's job. Scaling from the top left corner and
       sliding back by the same fraction the sliders name puts the container's
       window over the part of the enlarged picture they point at. */
    if (k > 1.0001) {
      v.style.transformOrigin = '0 0';
      v.style.transform = 'translate(' + (-(k - 1) * W * fx).toFixed(2) + 'px,' +
                                         (-(k - 1) * H * fy).toFixed(2) + 'px) scale(' + k.toFixed(5) + ')';
    } else {
      v.style.transformOrigin = '';
      v.style.transform = 'none';
    }
  }

  function initVideoFraming() {
    const vids = $$(FRAMED_VIDEO);
    if (!vids.length) return;

    if (!framingRO && 'ResizeObserver' in window) {
      framingRO = new ResizeObserver((entries) => {
        entries.forEach(en => {
          const v = en.target.querySelector('video');
          if (v) frameVideo(v);
        });
      });
    }

    vids.forEach((v) => {
      /* init() runs again on every section reload in the theme editor */
      if (!v.dataset.framed) {
        v.dataset.framed = '1';
        /* dimensions are unknown until metadata arrives; a poster frame can
           also settle late */
        v.addEventListener('loadedmetadata', () => frameVideo(v));
        v.addEventListener('loadeddata', () => frameVideo(v));
        if (framingRO && v.parentElement) framingRO.observe(v.parentElement);
      }
      frameVideo(v);
    });
  }

  /* ================= MOTION LAYER ================= */
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* scroll reveals */
  function initReveals(){
    if (reduceMotion || !('IntersectionObserver' in window)) {
      $$('[data-reveal],[data-reveal-group]').forEach(el => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    $$('[data-reveal],[data-reveal-group]').forEach(el => io.observe(el));
    // failsafe: nothing may remain hidden if the observer misfires
    setTimeout(() => {
      $$('[data-reveal],[data-reveal-group]').forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.5) el.classList.add('is-in');
      });
    }, 2500);
  }

  /* auto-tag sections and card groups so nothing needs manual markup */
  function tagForReveal(){
    $$('main section').forEach(sec => {
      /* a section that animates itself opts out: the blanket reveal would
         hold it at opacity 0 until the observer fires, which is wrong for a
         tall pinned panel that is on screen for several viewports */
      if (sec.hasAttribute('data-no-reveal')) return;
      if (!sec.hasAttribute('data-reveal')) sec.setAttribute('data-reveal','');
    });
    $$('.prail, .pgrid, .cgrid, .tiles, .feat3, .tcards, .tiergrid').forEach(g => {
      if (!g.hasAttribute('data-reveal-group')) g.setAttribute('data-reveal-group','');
    });
  }

  /* ================= INDEX LIST: cursor-tracked image preview =================
     On and Represent both use a type-first index whose image appears beside
     the pointer. Pointer-driven, desktop only, and never on a coarse pointer
     or under reduced motion - there the rows carry a small static thumbnail
     instead, rendered server-side. */
  function initIndexPeek(scope) {
    const roots = $$('[data-idx-peek]', scope || document);
    if (!roots.length) return;
    const fine = window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 900px)').matches;
    if (!fine || reduceMotion) return;

    roots.forEach((root) => {
      if (root.dataset.peekReady) return;
      root.dataset.peekReady = '1';

      const panel = document.createElement('div');
      panel.className = 'idx__peek';
      panel.setAttribute('aria-hidden', 'true');
      const img = document.createElement('img');
      img.alt = '';
      img.decoding = 'async';
      panel.appendChild(img);
      root.appendChild(panel);

      let x = 0, y = 0, queued = false, pw = 0, ph = 0;
      const measure = () => { pw = panel.offsetWidth; ph = panel.offsetHeight; };
      window.addEventListener('resize', () => { pw = 0; });

      /* The panel sits beside the pointer rather than under it, so it never
         covers the row title being read, and flips to the other side before it
         would run off the edge of the window. */
      const paint = () => {
        queued = false;
        if (!pw) measure();
        const pad = 18, offset = 28;
        let left = x + offset;
        if (left + pw > window.innerWidth - pad) left = x - offset - pw;
        left = Math.max(pad, Math.min(left, window.innerWidth - pw - pad));
        const top = Math.max(pad, Math.min(y - ph / 2, window.innerHeight - ph - pad));
        panel.style.transform = 'translate3d(' + left + 'px,' + top + 'px,0)' +
          (panel.classList.contains('is-on') ? ' scale(1)' : ' scale(.94)');
      };
      const track = (e) => {
        x = e.clientX; y = e.clientY;
        if (!queued) { queued = true; requestAnimationFrame(paint); }
      };

      $$('.idx__row', root).forEach((row) => {
        const src = row.getAttribute('data-peek');
        if (!src) return;
        row.addEventListener('mouseenter', (e) => {
          if (img.getAttribute('src') !== src) img.setAttribute('src', src);
          panel.classList.add('is-on');
          track(e);
        });
        row.addEventListener('mousemove', track);
        row.addEventListener('mouseleave', () => {
          panel.classList.remove('is-on');
          paint();
        });
      });
    });
  }

  /* header: hide going down, reveal going up */
  function initHeaderHide(){
    const hdr = $('.hdr');
    if (!hdr || reduceMotion) return;
    /* Off unless the header asks for it. Lifting the bar out of view left a
       band of the page sliding past above any sticky filter bar, which holds
       a header's height of space whether the header is there or not. */
    if (!hdr.hasAttribute('data-hide-on-scroll')) return;
    let last = window.scrollY, ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const openUi = $('.drawer.is-open') || $('.sheet.is-open') || $('.modal.is-open');
        if (!openUi && y > 220) {
          hdr.classList.toggle('is-hidden', y > last + 4);
        } else {
          hdr.classList.remove('is-hidden');
        }
        last = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------------- form guard ----------------
     Two cheap spam measures on the sign-up forms, both enforced here.

     The honeypot is a field nobody can see, tab to or autofill, so a
     person never puts anything in it and a bot filling every field does.
     The stopwatch is the time between the page arriving and the submit:
     a form sent within a couple of seconds was not read first.

     Neither stops a bot posting straight at Shopify's endpoint - only
     reCAPTCHA does that, and Shopify adds it itself once the store has it
     switched on. These stop the ones driving the page, which is most. */

  const GUARD_MIN_SECONDS = 2.5;

  function initFormGuard(){
    $$('form').forEach((form) => {
      const hp = form.querySelector('.nl-hp input');
      const guarded = form.querySelector('[data-form-guard]');
      if (!hp && !guarded) return;
      if (form.dataset.guarded) return;
      form.dataset.guarded = '1';
      /* when the form arrived, not when the page did: a section reloaded
         in the theme editor gets its own clock */
      const born = Date.now();

      form.addEventListener('submit', (e) => {
        const msg = form.querySelector('[data-form-guard-msg]');
        const say = (text) => {
          if (!msg) return;
          msg.textContent = text;
          msg.hidden = false;
        };
        if (hp && hp.value.trim() !== '') {
          e.preventDefault();
          say('That submission looked automated. Please try again.');
          return;
        }
        if ((Date.now() - born) / 1000 < GUARD_MIN_SECONDS) {
          e.preventDefault();
          say('One moment - please try that again.');
          /* the second attempt is past the window, so a real person is
             only ever stopped once */
          return;
        }
        if (msg) msg.hidden = true;
      });
    });
  }

  /* lazy image fade-in

     The CSS holds every lazy image at opacity:0 until .is-loaded lands, and
     this is the only thing that adds it. So an image is invisible unless it
     passes through here - and a sweep at boot only ever sees the page as it
     was then. Anything rendered later missed it: the drawer rewrites its
     line items after every cart change, so the moment you added something
     the product image was mounted, decoded, correctly sized, and painted at
     zero alpha. The wishlist, the drawer upsell and recently viewed are the
     same shape.

     Hence the observer: hydrating on mount is the only version of this that
     a later bit of rendering cannot forget to call. */
  function hydrateLazy(root){
    /* element or document only - innerHTML also hands the observer text nodes */
    if (!root || (root.nodeType !== 1 && root.nodeType !== 9)) return;
    const imgs = [];
    if (root.matches && root.matches('img[loading="lazy"]')) imgs.push(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('img[loading="lazy"]').forEach(i => imgs.push(i));
    }
    imgs.forEach(img => {
      /* init() runs again on every shopify:section:load, so without this the
         same image collects a fresh listener each time the editor repaints */
      if (img.dataset.lazyBound) return;
      img.dataset.lazyBound = '1';
      if (img.complete) { img.classList.add('is-loaded'); return; }
      const show = () => img.classList.add('is-loaded');
      img.addEventListener('load', show, { once: true });
      /* a broken or blocked src never fires load, and leaving it at zero
         alpha would hide the whole card rather than just the picture */
      img.addEventListener('error', show, { once: true });
    });
  }

  let lazyWatching = false;
  function initLazyFade(){
    hydrateLazy(document);
    if (lazyWatching || !document.body) return;
    lazyWatching = true;
    new MutationObserver(records => {
      records.forEach(r => r.addedNodes.forEach(hydrateLazy));
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* back to top */
  function initToTop(){
    const b = $('#ToTop');
    if (!b) return;
    window.addEventListener('scroll', () => {
      b.classList.toggle('is-on', window.scrollY > window.innerHeight * 1.2);
    }, { passive: true });
    b.addEventListener('click', () => window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }));
  }

  /* announcement pause / resume */
  function initAnnouncePause(){
    const btn = $('#AnnouncePause');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const paused = document.body.classList.toggle('announce-paused');
      btn.textContent = paused ? '\u25B6' : '\u2016';
      btn.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
    });
  }

  /* recently viewed (stores handles, renders on home/PDP) */
  const RV_KEY = 'bh_recent';
  function rvGet(){ try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch(e){ return []; } }
  function rvPush(handle){
    if (!handle) return;
    let l = rvGet().filter(h => h !== handle);
    l.unshift(handle);
    l = l.slice(0, 8);
    try { localStorage.setItem(RV_KEY, JSON.stringify(l)); } catch(e){}
  }
  function initRecentlyViewed(){
    const host = $('#RecentlyViewed');
    const current = document.body.dataset.productHandle;
    if (current) rvPush(current);
    if (!host) return;
    const list = rvGet().filter(h => h !== current);
    if (!list.length) { host.closest('section') && host.closest('section').remove(); return; }
    const rail = host.querySelector('.prail');
    /* each product's card comes from snippets/card-product, rendered by
       Shopify through sections/product-card, so it hovers, quick-adds and
       swaps colour like every other card on the site */
    Promise.all(list.slice(0,8).map(h =>
      fetch('/products/' + encodeURIComponent(h) + '?section_id=product-card')
        .then(r => r.ok ? r.text() : '')
        .then(html => {
          if (!html) return null;
          const card = new DOMParser().parseFromString(html, 'text/html').querySelector('.pcard');
          return card ? card.outerHTML : null;
        })
        .catch(() => null)
    )).then(cards => {
      const good = cards.filter(Boolean);
      if (!good.length) { host.closest('section') && host.closest('section').remove(); return; }
      rail.innerHTML = good.join('');
      host.classList.remove('rv-empty');
      hydrateCards();
    });
  }

  function updateBadgeFromDom() {
    const host = $('#CartItems');
    if (!host) return;
    const n = $$('.citem[data-key]', host).length;
    const tabn = $('#CartTabCount');
    if (tabn) { tabn.textContent = n; tabn.style.display = n ? '' : 'none'; }
  }


  /* ================= BAG PAGE (/cart) =================
     Every change goes through /cart/change.js and asks for this section back
     already rendered, so the totals, discounts and stock notes on the page
     always come from Liquid rather than being worked out again here. */
  let bagBusy = false;
  let bagDockObs = null;

  function bagRoot() { return $('#MainCart'); }

  function bagSwap(html) {
    const root = bagRoot();
    if (!root || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-bag-inner]');
    const inner = root.querySelector('[data-bag-inner]');
    if (fresh && inner) inner.replaceWith(fresh);
    initBagDock();
  }

  function bagReload() {
    const root = bagRoot();
    if (!root) return Promise.resolve();
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(root.dataset.sectionId))
      .then((r) => r.ok ? r.text() : '')
      .then(bagSwap)
      .catch(() => {});
  }

  function bagChange(row, qty) {
    const root = bagRoot();
    if (!root || !row || bagBusy) return Promise.resolve();
    bagBusy = true;
    row.classList.add(qty === 0 ? 'is-gone' : 'is-busy');
    const sid = root.dataset.sectionId;
    return fetch(cartUrls.change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: row.dataset.lineKey, quantity: qty, sections: [sid], sections_url: window.location.pathname })
    })
      .then((r) => r.json().then((d) => ({ ok: r.ok, data: d })))
      .then((res) => {
        if (!res.ok || !res.data.sections) {
          toast((res.data && res.data.description) || t('cart.general.update_error', 'Could not update your bag'));
          return bagReload().then(() => { bagBusy = false; });
        }
        bagSwap(res.data.sections[sid]);
        renderCart(res.data);
        bagBusy = false;
      })
      .catch(() => {
        bagBusy = false;
        row.classList.remove('is-busy', 'is-gone');
        toast(t('cart.general.update_error', 'Could not update your bag'));
      });
  }

  function bagCommitInput(input) {
    const row = input.closest('.bline');
    if (!row) return;
    let n = parseInt(input.value, 10);
    if (isNaN(n) || n < 0) n = 0;
    const max = parseInt(input.getAttribute('max'), 10);
    if (!isNaN(max) && n > max) { n = max; toast('Only ' + max + ' available'); }
    if (String(n) === input.defaultValue) { input.value = n; return; }
    bagChange(row, n);
  }

  function bagApplyDiscount() {
    const f = $('#BagDiscount');
    const code = (f && f.value || '').trim();
    if (!code) { toast('Enter a code first'); if (f) f.focus(); return; }
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrls.cart);
  }

  document.addEventListener('click', (e) => {
    const root = bagRoot();
    if (!root || !root.contains(e.target)) return;

    const step = e.target.closest('[data-bag-qty]');
    if (step) {
      e.preventDefault();
      const input = step.closest('.bqty').querySelector('[data-bag-input]');
      const cur = parseInt(input.value, 10) || 0;
      input.value = Math.max(0, cur + (step.dataset.bagQty === 'up' ? 1 : -1));
      bagCommitInput(input);
      return;
    }

    const rm = e.target.closest('[data-bag-remove]');
    if (rm) { e.preventDefault(); bagChange(rm.closest('.bline'), 0); return; }

    const save = e.target.closest('[data-bag-save]');
    if (save) {
      e.preventDefault();
      const handle = save.dataset.bagSave;
      const list = wishGet();
      if (list.indexOf(handle) === -1) { list.unshift(handle); wishSet(list); }
      paintWish();
      bagChange(save.closest('.bline'), 0).then(() => toast('Saved to your wishlist'));
      return;
    }

    if (e.target.closest('[data-bag-discount]')) { e.preventDefault(); bagApplyDiscount(); }
  });

  /* Enter inside the bag form would otherwise press its first submit
     button - Checkout - so it commits the field instead */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const input = e.target.closest && e.target.closest('[data-bag-input], #BagDiscount');
    if (!input) return;
    e.preventDefault();
    if (input.id === 'BagDiscount') bagApplyDiscount();
    else bagCommitInput(input);
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches && e.target.matches('[data-bag-input]')) { bagCommitInput(e.target); return; }
    if (e.target.id === 'BagNote') {
      fetch((cartUrls.cart) + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: e.target.value })
      }).catch(() => {});
    }
  });

  /* the drawer can change the bag while this page is open */
  document.addEventListener('bh:cart-updated', () => {
    if (bagRoot() && !bagBusy) {
      const shown = $$('#MainCart .bline').length;
      const n = $$('#CartItems .citem[data-key]').length;
      if (shown !== n || $('#CartDrawer.is-open')) bagReload();
    }
  });

  /* phone: show the docked checkout bar until the real button is on screen */
  function initBagDock() {
    if (bagDockObs) { bagDockObs.disconnect(); bagDockObs = null; }
    const dock = $('[data-bag-dock]');
    const btn = $('#BagCheckout');
    if (!dock || !btn || !('IntersectionObserver' in window)) return;
    bagDockObs = new IntersectionObserver((entries) => {
      entries.forEach((en) => dock.classList.toggle('is-on', !en.isIntersecting));
    });
    bagDockObs.observe(btn);
  }

  /* Cards that arrive after page load - recommendations, recently viewed -
     need the same wiring the page gave the cards it started with. Each of
     these skips a card or arrow it has already bound. */
  function hydrateCards() {
    initQuickAdd();
    initHoverPreload();
    initRails();
    paintWish();
  }

  /* Recommendation rows - "You may also like" under the bag, "Complete the
     look" under the product: Shopify renders the section with its
     recommendations and the script swaps the filled rail in. A row whose
     first request comes back empty tries data-fallback-url once. */
  function initRecs() {
    $$('[data-recs]').forEach((host) => {
      if (host.dataset.loaded) return;
      host.dataset.loaded = '1';
      const load = (url) => fetch(url)
        .then((r) => r.ok ? r.text() : '')
        .then((html) => {
          const doc = html ? new DOMParser().parseFromString(html, 'text/html') : null;
          const rail = doc && doc.querySelector('[data-recs-rail]');
          if (!rail || !rail.querySelector('.pcard')) {
            const next = host.dataset.fallbackUrl;
            if (next && next !== url) return load(next);
            return;
          }
          host.querySelector('[data-recs-rail]').innerHTML = rail.innerHTML;
          host.hidden = false;
          hydrateCards();
        });
      load(host.dataset.url).catch(() => {});
    });
  }

  function initBag() {
    initRecs();
    if (!bagRoot()) return;
    initBagDock();
  }

  /* ---------- init ---------- */
  function init() {
    initProduct();
    initTier();
    initRails();
    initClubFilter();
    initHeaderScroll();
    initPlp();
    initGallery();
    initProductView();
    initZoom();
    initRetail();
    initStoreHours();
    initMobilePanels();
    initPopup();
    initQuickAdd();
    initHoverPreload();
    initMegaMenu();
    initMarquee();
    initIndexPeek();
    initVideoLoop();
    initVideoFraming();
    initFormGuard();
    tagForReveal();
    initReveals();
    initHeaderHide();
    initLazyFade();
    initToTop();
    initAnnouncePause();
    initRecentlyViewed();
    initBag();
    paintWish();
    /* the drawer is rendered server-side in Liquid; nothing to fetch on load */
    updateBadgeFromDom();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', (e) => {
    if (e && e.target) teardownMarquee(e.target);
    init();
  });
  document.addEventListener('shopify:section:unload', (e) => {
    if (e && e.target) teardownMarquee(e.target);
  });
})();
